const PRODUCTION = '';

function getHost(delim) {
    const host = location.host.split(delim);
    if (host.length < 2) {
        return PRODUCTION;
    }
    return host[0];
}

function getNamespace() {
    const attendeeHost = getHost('-attendees');
    if (!attendeeHost) {
        return getHost('-partners');
    }
    return attendeeHost;
}

const namespace = getNamespace();
export default namespace;
